<template>
  <v-container class="mt-12 pt-8" style="background:#efefef;">
    <v-row style="background:#efefef;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-card :loading="loading">
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-row class="align-center">
                      <v-col cols="2" class="text-center" TITLE>
                        <v-icon size="40" color="secondary">person</v-icon>
                      </v-col>
                      <v-col cols="10" TITLE>
                        <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">{{ i18n.categories }}</div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field prepend-inner-icon="search" type="text" outlined label="Search" compact="comfort"
                      clearable hide-details dense v-model="search"
                      @click:clear="() => { search = null; pageByNumber(page) }" />
                  </v-col>

                  <v-col md="4" sm="6" cols="12">
                    <DatePicker label="Created at" hide-details :value.sync="filters.created_at" range />
                  </v-col>

                  <v-col md="4" sm="6" cols="12">
                    <v-autocomplete label="Sort by" :items="sortBy" outlined dense hide-details
                      v-model="filters.sort_by" />
                  </v-col>


                  <v-col md="4" sm="6" cols="12">
                    <v-autocomplete label="Sort direction" :items="sortDirection" outlined dense hide-details
                      v-model="filters.sort_direction" />
                  </v-col>

                  <v-col cols="12">
                    <v-row>
                      <v-col cols="auto" class="mx-auto">
                        <v-btn color="primary" @click.prevent="pageByNumber(page)">
                          <v-icon small>filter_list</v-icon>
                          <span>Filter</span>
                        </v-btn>
                        <v-btn class="ml-4" color="deep-orange" dark @click.prevent="reset()">
                          <v-icon small>restart_alt</v-icon>
                          <span>Reset</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>

                  <v-col cols="12">
                    <Paging @createResource="createResource" :resourceSettings="resourceSettings" :resource="resource.categories"
                      @loadResource="loadResource" @pageByNumber="pageByNumber" />
                  </v-col>

                  <ListCategories v-if="resource.categories" @editResource="editResource" @triggerDeleteResource="triggerDeleteResource"
                    :categories="resource.categories.data" />


                  <MultiDialog :dialog="dialog" :loading="loading" :resourceSettings="resourceSettings"
                    :deleting="deleting" :resourceKeys="resourceKeys" :newResource="newResource"
                    @closeDialog="resetDialog" @deleteResource="deleteResource" @updateResource="updateResource"
                    @postResource="postResource" />
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Paging from '@/components/Paging.vue'
import DatePicker from '@/components/DatePicker.vue'
import MultiDialog from '@/components/multiDialog.vue'
import ListCategories from '@/components/ListCategories.vue'

export default {
  components: {
    Paging,
    ListCategories,
    MultiDialog,
    DatePicker,
  },
  data() {
    return {
      search: null,
      page: 1,
      resourceSettings: {
        resourceName: null,
        search: false,
        create: true,
        pagination: true,
      },
      resourceKeys: [
        { name: 'name', label: 'name', type: 'text', required: true },
        { name: 'gama_grand_category_id', label: 'grand_category', items: 'grand_categories', type: 'select', data: [], source: 'db', required: true, },
      ],
      resource: {},
      newResource: {},
      loading: false,
      deleting: false,
      dialog: false,
      sortBy: [
        { text: 'Name', value: 'name' },
        { text: 'Created at', value: 'created_at' },
        { text: 'Leads count', value: 'leads_count' },
      ],
      sortDirection: [
        { text: 'Ascending', value: 'asc' },
        { text: 'Descending', value: 'desc' },
      ],
      filters: {
        created_at: [],
        sor_by: null,
        sort_direction: null
      },
      grand_categories: []
    }
  },
  methods: {
    async loadItems() {
      return new Promise(async (res, rej) => {
        let ks = this.resourceKeys.filter(x => x.type == 'select' && x.source == 'db');
        (async x => {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = this.resource[f.items]
            let maps = t.map(x => {
              let t = x.name ? x.name : null
              return { ...x, text: t, [`${f.name}`]: x.id }
            })
            f.data = maps
          }
          res(true)
        })()
      })
    },
    async deleteResource(resource) {
      this.loading = true
      await this.$store.dispatch('deleteResource', { resource: `/gama-categories/${this.newResource.id}`, value: resource })
      await this.resetDialog(true)
    },
    async updateResource(resource) {
      this.loading = true
      await this.$store.dispatch('putResource', { resource: `/gama-categories/${this.newResource.id}`, value: resource })
      await this.resetDialog(true)
    },
    createResource() {
      this.resetDialog()
      this.dialog = true
    },
    async postResource(resource) {
      this.loading = true
      await this.$store.dispatch('postResource', { resource: `/gama-categories`, value: resource })
      await this.resetDialog(true)
    },
    editResource(resource) {
      this.newResource = { ...resource }
      this.dialog = true
    },
    triggerDeleteResource(resource) {
      this.newResource = { ...resource }
      this.deleting = true
      this.dialog = true
    },
    async resetDialog(withReload = false) {
      this.dialog = false
      this.deleting = false
      this.loading = false
      this.newResource = {}

      if (withReload)
        await this.loadResource()
    },
    setResourceName() {
      this.resourceSettings.resourceName = 'categories'
    },
    addNewIncludedWord() {
      if (this.include_word) {
        this.included_words.push({
          text: this.include_word, value: this.include_word
        })

        this.filters.include_words.push(this.include_word)
        this.include_word = null
      }
    },
    addNewExcludedWord() {
      if (this.exclude_word) {
        this.excluded_words.push({
          text: this.exclude_word, value: this.exclude_word
        })

        this.filters.exclude_words.push(this.exclude_word)
        this.exclude_word = null
      }
    },
    remove(item, field) {
      let index = this.filters[field].indexOf(item.value)
      if (item.id) {
        index = this.filters[field].indexOf(item.id)
      }
      if (index >= 0) this.filters[field].splice(index, 1)
    },
    async loadResource() {
      this.loading = true
      let data = await this.$store.dispatch('getResource', { resource: '/gama-categories' })
      this.resource = data
      this.search = null
      this.loading = false
    },
    async reset() {
      this.search = null
      this.filters = {
        created_at: [],
        sor_by: null,
        sort_direction: null
      }
      this.pageByNumber(this.page)
    },
    async pageByNumber(page) {
      this.loading = true
      this.page = page
      if (this.search) {
        let data = await this.$store.dispatch('getResource', { resource: `/gama-categories?page=${page}` + this._filters + `&search=${this.search}` })
        this.resource = data
      }
      else {
        let data = await this.$store.dispatch('getResource', { resource: `/gama-categories?page=${page}` + this._filters })
        this.resource = data
      }
      this.loading = false
    }
  },
  computed: {
    _filters() {
      let filter = '';

      if (this.filters.created_at.length > 0) {
        filter += `&created_at=${this.filters.created_at}`
      }

      if (this.filters.sort_by) {
        filter += `&sort_by=${this.filters.sort_by}`
      }

      if (this.filters.sort_direction) {
        filter += `&sort_direction=${this.filters.sort_direction}`
      }

      return filter
    },
    api() {
      return this.$store.state.settings.apiBase
    },
    users() {
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      return this.$store.state.users.filter(x => {
        if (!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site() {
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin() {
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language() {
      return this.$store.state.language
    },
    globalLoading() {
      return this.$store.state.globalLoading
    },
    user() {
      return this.$store.state.user
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
    routeTitle() {
      let main = this.$store.state.menu.filter(x => x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x => x.subs)).filter(x => x).filter(x => x.path == this.$route.path)
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles() {
      return this.$store.state.userRoles
    },
    notifications() {
      return this.$store.state.notifications
    },
  },
  async created() {
    await this.loadResource()
    await this.loadItems()
    this.setResourceName()
  }
}
</script>
<style scoped>
*:not(i) {
  font-family: 'Poppins', sans-serif;
}
</style>